module.exports = __webpack_public_path__ + "9c742dd85d2541ef452240dac22df745.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/kilo-systeme/04.jpg
// module id = /BOV
// module chunks = 0